import type { BookingMessages } from "./types";

/**
 * Gasttexte, wenn die Online-Strecke auf Anfrage steht.
 * Das Wort „Buchung“ und eine Buchungsnummer wirken sonst wie eine Zusage.
 */
export function applyInquiryWording(messages: BookingMessages): BookingMessages {
  if (messages.common.night === "Nacht") {
    return {
      ...messages,
      flow: {
        ...messages.flow,
        pageSubtitle:
          "Unverbindliche Anfrage – wir prüfen Ihre Angaben und melden uns per E-Mail.",
        configLoadError: "Einstellungen für die Online-Anfrage konnten nicht geladen werden.",
        holdCreateError: "Die Vormerkung konnte nicht angelegt werden.",
        submitError: "Anfrage konnte nicht gesendet werden.",
        holdExpired: "Die Vormerkung ist abgelaufen. Bitte wählen Sie erneut eine Platzkategorie.",
        acceptTerms: "Bitte bestätigen Sie die Bedingungen.",
        savedProfileHint:
          "Wir übernehmen Ihre gespeicherten Daten. Fehlende Pflichtangaben können Sie unten ergänzen.",
        termsSuffix: "zur Kenntnis genommen und sende eine unverbindliche Anfrage.",
      },
      validation: {
        ...messages.validation,
        sameDayCutoffBlocked:
          "Für Anreisen am heutigen Tag sind Online-Anfragen ab {time} Uhr nicht mehr möglich.",
      },
      availability: {
        ...messages.availability,
        alternativesHint: (nights, nightLabel) =>
          `Gewünscht: ${nights} ${nightLabel}. Mit einem Klick übernehmen Sie den Termin.`,
      },
      arrivalType: {
        ...messages.arrivalType,
        noneAvailable:
          "Für die Online-Anfrage sind derzeit keine Anreisearten freigegeben. Bitte wenden Sie sich an den Campingplatz.",
      },
      login: {
        ...messages.login,
        subtitleBooking:
          "Schon einmal bei uns? Melden Sie sich mit Ihrer E-Mail an – Ihre Daten werden in die Anfrage übernommen.",
        backToBooking: "Zurück zur Anfrage",
        toBooking: "Zur Online-Anfrage",
      },
      portal: {
        ...messages.portal,
        upcomingEmpty:
          "Keine geplanten Aufenthalte. Senden Sie Ihre nächste Anfrage direkt online.",
        bookNow: "Neue Anfrage",
      },
      season: {
        ...messages.season,
        outsideSeason: "Der gewählte Zeitraum liegt außerhalb der Saison.",
        bookableOnly: "Online anfragbar während der Saison",
      },
      holdTimer: {
        label: "Vorgemerkt für",
        hint: "So lange halten wir den Stellplatz für Ihre Anfrage frei.",
        expired: "Die Vormerkung ist abgelaufen. Bitte wählen Sie erneut eine Platzkategorie.",
      },
    };
  }

  return {
    ...messages,
    flow: {
      ...messages.flow,
      pageSubtitle: "Non-binding request – we will review your details and reply by email.",
      configLoadError: "Online request settings could not be loaded.",
      holdCreateError: "The hold could not be created.",
      submitError: "Request could not be sent.",
      holdExpired: "Your hold has expired. Please select a pitch category again.",
      acceptTerms: "Please accept the terms.",
      savedProfileHint:
        "We use your saved details. You can complete any missing required fields below.",
      termsSuffix: "and am submitting a non-binding request.",
    },
    validation: {
      ...messages.validation,
      sameDayCutoffBlocked: "Online requests for arrival today are no longer possible from {time}.",
    },
    availability: {
      ...messages.availability,
      alternativesHint: (nights, nightLabel) =>
        `Requested: ${nights} ${nightLabel}. One click applies the dates.`,
    },
    arrivalType: {
      ...messages.arrivalType,
      noneAvailable:
        "No arrival types are currently available for the online request. Please contact the campsite.",
    },
    login: {
      ...messages.login,
      subtitleBooking:
        "Been here before? Sign in with your email – your details will be used in the request.",
      backToBooking: "Back to request",
      toBooking: "To online request",
    },
    portal: {
      ...messages.portal,
      upcomingEmpty: "No planned stays. Send your next request online.",
      bookNow: "New request",
    },
    season: {
      ...messages.season,
      outsideSeason: "The selected period is outside the season.",
      bookableOnly: "Online requests are available during the season",
    },
    holdTimer: {
      label: "Held for",
      hint: "We hold the pitch for your request for this long.",
      expired: "Your hold has expired. Please select a pitch category again.",
    },
  };
}
